






































































import mixins from 'vue-typed-mixins'
import WindowResizeListener from '@/abstract/WindowResizeListener'
import VisibleColumns from '@/abstract/VisibleColumns'
import PaidLabel from '@/components/PaidLabel/PaidLabel.vue'
import PageChecking from '@/components/DataTable/DataTablePageChecking.vue'
import DataTableHeader from '@/components/DataTable/DataTableHeader.vue'
import Kanban from '@/components/DataTable/Kanban/Kanban.vue'
import DataTableBody from '@/components/DataTable/DataTableBody.vue'
import PaginationBlock from '@/components/DataTable/Pagination/PaginationBlock.vue'
import DataTableFiltersBlock from '@/components/DataTable/Filters/DataTableFiltersBlock.vue'
import ColumnSorting from '@/components/DataTable/Columns/ColumnSorting.vue'
import DataTableRecordingInfo from '@/components/DataTable/RecordInfo/DataTableRecordingInfo.vue'
import {
  DataTable,
  CheckboxValue,
  DataTableColumnItem,
  ItemsForDownload,
  TableSetting,
} from '@/models/dataTable'
import Loader from '@/components/Common/Loader.vue'
import EmptyResult from '@/components/EmptyResult/EmptyResult.vue'
import iconCaretDown from '@/assets/svg/rounded/caret-down.svg?inline'
import CheckboxColumn from '@/components/DataTable/Columns/Common/CheckboxColumn.vue'
import ActionColumn from '@/components/DataTable/Columns/Common/ActionColumn.vue'
import CustomCheckbox from '@/components/Common/CustomCheckbox.vue'
import { LocalStorageActionTypes } from '@/store/modules/local-storage/actions'
import { Company } from '@/models/companies'
import { UserFull } from '@/models/users'
import { ETableView } from '@/constants/dataTable'

interface Data {
  checkedItems: Array<CheckboxValue>
  uncheckedItems: Array<CheckboxValue>
  showAllChecking: boolean
  allCheck: boolean
  showSorting: boolean
  showRecordInfo: boolean
}

interface Props {
  tableSetting: TableSetting
  tableData: DataTable
}

interface Methods {
  setCheckboxValues: (values: CheckboxValue[]) => void
  checkAllOnPage: (checkAll: boolean) => void
  showAllCheck: (status: boolean) => void
  checkAll: () => void
  itemsOnPage: (arr: Array<CheckboxValue>) => number
  checkAllOnAllPage: (status: boolean) => void
  resetChecks: () => void
}

interface Computed {
  checkboxValues: CheckboxValue[]
  partialCheckedOnAllPage: boolean
  partialCheckedOnPage: boolean
  isCheckedAll: boolean
  allCheckedOnPage: boolean
  tableGridStyle: string
  tableDataColumns: Array<DataTableColumnItem>
  totalChecked: number
  showMobileRecorInfo: boolean
  totalCheckVisible: boolean
  itemsForDownload: ItemsForDownload
  showDataTable: boolean
  activeCompany: Company | undefined
  getMe: UserFull
  allCheckHandler: boolean
  showTableView: boolean
  showKanbanView: boolean
}

export default mixins(WindowResizeListener, VisibleColumns).extend<
  Data,
  Methods,
  Computed,
  Props
>({
  components: {
    PaidLabel,
    PageChecking,
    DataTableHeader,
    DataTableBody,
    PaginationBlock,
    DataTableFiltersBlock,
    DataTableRecordingInfo,
    Kanban,
    Loader,
    EmptyResult,
    CheckboxColumn,
    ActionColumn,
    iconCaretDown,
    CustomCheckbox,
    ColumnSorting,
  },
  props: {
    tableSetting: {
      required: true,
    },
    tableData: {
      required: true,
    },
  },
  data() {
    return {
      checkedItems: [],
      uncheckedItems: [],
      showAllChecking: false,
      allCheck: false,
      showFilters: false,
      showSorting: false,
      showRecordInfo: false,
    }
  },
  methods: {
    setCheckboxValues(values) {
      this.checkboxValues = values
    },
    checkAllOnPage(checkAll) {
      if (!checkAll && this.allCheck) {
        this.tableData.data.forEach(elem => {
          this.checkedItems.splice(this.checkedItems.indexOf(elem.id), 1)
          this.uncheckedItems.push(elem.id)
        })
      }
      if (!checkAll && !this.allCheck) {
        this.tableData.data.forEach(elem => {
          this.checkedItems.splice(this.checkedItems.indexOf(elem.id), 1)
        })
      }
      if (checkAll && this.allCheck) {
        this.tableData.data.forEach(elem => {
          this.checkedItems.push(elem.id)
          this.uncheckedItems.splice(this.uncheckedItems.indexOf(elem.id), 1)
        })
        this.checkedItems = [...new Set(this.checkedItems)]
      }
      if (checkAll && !this.allCheck) {
        this.tableData.data.forEach(elem => {
          this.checkedItems.push(elem.id)
        })
        this.checkedItems = [...new Set(this.checkedItems)]
      }
    },
    checkAllOnAllPage(status) {
      if (!status && this.uncheckedItems.length) {
        this.allCheck = true
        this.uncheckedItems = []
        this.checkAll()
        return
      }
      if (!status && this.partialCheckedOnAllPage) {
        this.allCheck = true
        this.checkAll()
        return
      }
      this.allCheck = status
      this.checkAll()
    },
    checkAll() {
      if (this.allCheck) {
        const checkedItems = this.tableData.data.filter(elem => {
          return !this.uncheckedItems.includes(elem.id)
        })
        this.checkedItems = [
          ...new Set(
            this.checkedItems.concat(Array.from(checkedItems, ({ id }) => id)),
          ),
        ]
      }
      if (!this.allCheck) {
        this.checkedItems = []
        this.uncheckedItems = []
      }
    },
    showAllCheck(status) {
      this.showAllChecking = status
    },
    itemsOnPage(arr) {
      const items = this.tableData.data.filter(elem => {
        return arr.includes(elem.id)
      })
      return items.length
    },
    resetChecks() {
      this.checkedItems = []
      this.uncheckedItems = []
      this.allCheck = false
    },
  },
  computed: {
    checkboxValues: {
      get() {
        return this.checkedItems
      },
      set(value) {
        if (
          this.allCheck &&
          this.tableData.data.length >
            this.itemsOnPage(value) + this.itemsOnPage(this.uncheckedItems)
        ) {
          const newUncheckedItem = this.tableData.data.filter(elem => {
            return (
              !value.includes(elem.id) && !this.uncheckedItems.includes(elem.id)
            )
          })
          this.uncheckedItems.push(newUncheckedItem[0].id)
        }
        if (
          this.allCheck &&
          this.tableData.data.length <
            this.itemsOnPage(value) + this.itemsOnPage(this.uncheckedItems)
        ) {
          const newCheckedItem = value.filter(elem => {
            return this.uncheckedItems.includes(elem)
          })
          this.uncheckedItems.splice(
            this.uncheckedItems.indexOf(newCheckedItem[0]),
            1,
          )
        }
        this.checkedItems = value
      },
    },
    isCheckedAll() {
      return (
        this.checkedItems.length === this.tableData.pagination.total ||
        (this.allCheck && this.uncheckedItems.length === 0)
      )
    },
    partialCheckedOnAllPage() {
      return (
        (this.checkedItems.length < this.tableData.pagination.total &&
          this.checkedItems.length > 0 &&
          !this.allCheck) ||
        (this.uncheckedItems.length < this.tableData.pagination.total &&
          this.uncheckedItems.length > 0 &&
          this.allCheck)
      )
    },
    partialCheckedOnPage() {
      let include = false
      this.tableData.data.forEach(elem => {
        if (this.checkedItems.includes(elem.id)) {
          include = true
        }
      })
      return this.checkedItems.length > 0 && !this.allCheckedOnPage && include
    },
    allCheckedOnPage: {
      get() {
        let include = true
        this.tableData.data.forEach(elem => {
          if (!this.checkedItems.includes(elem.id)) {
            include = false
          }
        })
        return include
      },
      set(value) {
        this.checkAllOnPage(value)
      },
    },
    totalChecked() {
      if (this.allCheck) {
        return this.tableData.pagination.total - this.uncheckedItems.length
      }
      return this.checkedItems.length
    },
    tableGridStyle() {
      let allColumnStyle = 'minmax(34px, 34px)'
      function itemColumnStyle(column: string) {
        switch (column) {
          case 'number':
            return 'minmax(auto, auto)'
          case 'string':
            return 'minmax(auto, auto)'
          case 'boolean':
            return 'minmax(80px, auto)'
          case 'date':
            return 'minmax(150px, auto)'
          default:
            return 'minmax(90px, auto)'
        }
      }
      this.tableDataColumns.forEach(elem => {
        if (this.isVisibleColumn(this.tableSetting.directory, elem.key)) {
          allColumnStyle = `${allColumnStyle} ${itemColumnStyle(elem.type)}`
        }
      })
      allColumnStyle = `grid-template-columns:${allColumnStyle} minmax(50px, 50px)`
      return allColumnStyle
    },
    tableDataColumns() {
      return this.tableData.columns.filter(elem => elem.visible)
    },
    showMobileRecorInfo() {
      return this.isMobile && !!this.$route.query.record
    },
    totalCheckVisible() {
      return !this.isMobile && this.totalChecked !== 0
    },
    itemsForDownload() {
      const obj = {
        id: this.checkedItems,
        exept: false,
      }
      if (this.allCheck) {
        ;(obj.id = this.uncheckedItems), (obj.exept = true)
      }
      this.$emit('input', obj)
      return obj
    },
    showDataTable() {
      return this.tableData.data && this.tableData.data.length > 0
    },
    activeCompany() {
      return this.$store.getters.getActiveCompany
    },
    getMe() {
      return this.$store.getters.getMe
    },
    allCheckHandler: {
      get() {
        return this.allCheck
      },
      set(value) {
        this.checkAllOnAllPage(value)
      },
    },
    showTableView() {
      return this.tableSetting.view === ETableView.table
    },
    showKanbanView() {
      return this.tableSetting.view === ETableView.kanban
    },
  },
  mounted() {
    this.$store.dispatch(LocalStorageActionTypes.GetLocalStorage)
  },
  watch: {
    tableData() {
      if (this.allCheck) {
        this.checkAll()
      }
    },
    '$route.query.filter'() {
      this.allCheck = false
      ;(this.checkedItems = []), (this.uncheckedItems = [])
    },
    activeCompany(company) {
      if (this.getMe.roles && this.getMe.roles[company.id].id == 4) {
        this.$router.push({ path: '/scripts' })
      }
      this.resetChecks()
    },
  },
})
